var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-dialog",
        {
          directives: [{ name: "dialogDrag", rawName: "v-dialogDrag" }],
          attrs: {
            title: _vm.title,
            "close-on-click-modal": false,
            visible: _vm.visible,
          },
          on: {
            "update:visible": function ($event) {
              _vm.visible = $event
            },
          },
        },
        [
          _c(
            "el-form",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.loading,
                  expression: "loading",
                },
              ],
              ref: "inputForm",
              class: _vm.method === "view" ? "readonly" : "",
              attrs: {
                model: _vm.inputForm,
                size: "small",
                disabled: _vm.method === "view",
                "label-width": "120px",
              },
            },
            [
              _c(
                "el-row",
                { attrs: { gutter: 15 } },
                [
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: "所属公司",
                            prop: "company.id",
                            rules: [
                              {
                                required: true,
                                message: "所属公司不能为空",
                                trigger: "blur",
                              },
                            ],
                          },
                        },
                        [
                          _c("SelectTree", {
                            ref: "company",
                            attrs: {
                              props: {
                                value: "id", // ID字段名
                                label: "name", // 显示名称
                                children: "children", // 子级字段名
                              },
                              url: "/sys/office/treeData?type=2",
                              value: _vm.inputForm.company.id,
                              clearable: true,
                              accordion: true,
                            },
                            on: {
                              getValue: function (value) {
                                _vm.inputForm.company.id = value
                              },
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: "归属部门",
                            prop: "office.id",
                            rules: [
                              {
                                required: true,
                                message: "归属部门不能为空",
                                trigger: "blur",
                              },
                            ],
                          },
                        },
                        [
                          _c("SelectTree", {
                            ref: "office",
                            attrs: {
                              props: {
                                value: "id", // ID字段名
                                label: "name", // 显示名称
                                children: "children", // 子级字段名
                              },
                              url: "/sys/office/treeData?type=2",
                              value: _vm.inputForm.office.id,
                              clearable: true,
                              accordion: true,
                            },
                            on: {
                              getValue: function (value) {
                                _vm.inputForm.office.id = value
                              },
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: { label: "员工", prop: "user.id", rules: [] },
                        },
                        [
                          _c("user-select", {
                            attrs: { limit: 1, value: _vm.inputForm.user.id },
                            on: {
                              getValue: function (value) {
                                _vm.inputForm.user.id = value
                              },
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: "归属区域",
                            prop: "area.id",
                            rules: [],
                          },
                        },
                        [
                          _c("SelectTree", {
                            ref: "area",
                            attrs: {
                              props: {
                                value: "id", // ID字段名
                                label: "name", // 显示名称
                                children: "children", // 子级字段名
                              },
                              url: "/sys/area/treeData",
                              value: _vm.inputForm.area.id,
                              clearable: true,
                              accordion: true,
                            },
                            on: {
                              getValue: function (value) {
                                _vm.inputForm.area.id = value
                              },
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: "请假开始日期",
                            prop: "beginDate",
                            rules: [],
                          },
                        },
                        [
                          _c("el-date-picker", {
                            staticStyle: { width: "100%" },
                            attrs: {
                              type: "datetime",
                              "value-format": "yyyy-MM-dd HH:mm:ss",
                              placeholder: "选择日期时间",
                            },
                            model: {
                              value: _vm.inputForm.beginDate,
                              callback: function ($$v) {
                                _vm.$set(_vm.inputForm, "beginDate", $$v)
                              },
                              expression: "inputForm.beginDate",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: "请假结束日期",
                            prop: "endDate",
                            rules: [],
                          },
                        },
                        [
                          _c("el-date-picker", {
                            staticStyle: { width: "100%" },
                            attrs: {
                              type: "datetime",
                              "value-format": "yyyy-MM-dd HH:mm:ss",
                              placeholder: "选择日期时间",
                            },
                            model: {
                              value: _vm.inputForm.endDate,
                              callback: function ($$v) {
                                _vm.$set(_vm.inputForm, "endDate", $$v)
                              },
                              expression: "inputForm.endDate",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  attrs: { size: "small" },
                  on: {
                    click: function ($event) {
                      _vm.visible = false
                    },
                  },
                },
                [_vm._v("关闭")]
              ),
              _vm.method != "view"
                ? _c(
                    "el-button",
                    {
                      directives: [
                        { name: "noMoreClick", rawName: "v-noMoreClick" },
                      ],
                      attrs: { size: "small", type: "primary" },
                      on: {
                        click: function ($event) {
                          return _vm.doSubmit()
                        },
                      },
                    },
                    [_vm._v("确定")]
                  )
                : _vm._e(),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }